import MetaHead from '../components/MetaHead';
import { SygeforsikringDanmarkLogo } from '../components/SygeforsikringDanmark';

export default function InfoPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12">
      <MetaHead 
        title="Velkomstbrev og praktisk info - Din Privat Psykolog"
        description="Velkommen til et samtaleforløb hos klinisk psykolog Marie Aagaard Larsen. Information om ankomst, varighed, betaling og praktiske forhold."
        ogTitle="Velkomstbrev og praktisk info - Din Privat Psykolog"
        ogDescription="Velkommen til et samtaleforløb hos klinisk psykolog Marie Aagaard Larsen. Praktisk information om ankomst, tidsbestilling og forløb."
        ogImage="https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/61a0bb4f-47a8-4ecb-a747-8c6184fb1879_3bd59b5a.jpg"
      />

      {/* Header med personlig velkomst */}
      <div className="border-b border-[#E0D7C6] pb-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="space-y-3 max-w-3xl">
            <span className="text-xs font-semibold tracking-wider uppercase text-[#C6A868] block">
              Information til nye og nuværende klienter
            </span>
            <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#5f7365]">
              Velkomstbrev og praktisk info
            </h1>
            <p className="text-base sm:text-lg text-[#3B4D42] leading-relaxed pt-1">
              Velkommen til et samtaleforløb i min private psykologklinik. Hermed et lille informationsbrev med oplysninger om dét at gå til privat psykolog hos mig.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-8 text-[#5f7365] text-sm sm:text-base leading-relaxed">
        
        <div className="text-[#5f7365] font-semibold text-base font-serif border-b border-[#EDE6D8] pb-3">
          Jeg ser frem til dit besøg i klinikken
        </div>

        <div className="space-y-6 divide-y divide-[#EDE6D8]">
          
          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Du bestemmer formen
            </h2>
            <p>
              Klinik samtaler, videokonsultationer eller terapi i det fri (walk and talk). Det hele kan kombineres undervejs efter ønske/behov.
            </p>
          </div>

          <div className="pt-4 space-y-3">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Adresse og ankomst
            </h2>
            <p>
              Torvegade 8, 6510 Gram. Klinikken ligger på 1. sal i min rødstensvilla fra 1926. Du går ind gennem det grønne stakit / havelågen, følger flisegangen og ringer på klokken ved døren, hvor der står <em>Privat Psykolog</em>.
            </p>
            <p className="text-xs text-[#52685B]">
              Parkering: Der findes gode parkeringsmuligheder lige overfor huset ved Røde Kors uden tidsbegrænsning.
            </p>
            <div className="pt-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="overflow-hidden border border-[#EDE6D8]">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/7f0d58f1-d94f-4b01-b1cd-7d855932c06a.jpg"
                  alt="Klinikken på Torvegade 8 i Gram - Rødstensvilla"
                  className="w-full h-48 object-cover object-center"
                />
                <p className="p-2 text-[11px] text-[#5A7364] bg-[#FAF8F5]">Rødstensvillaen på Torvegade 8 i Gram</p>
              </div>
              <div className="overflow-hidden border border-[#EDE6D8]">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/4320192f-3e8c-4ece-bf20-999699adc5ee.jpeg"
                  alt="Indgang til Privat Psykolog via flisegang"
                  className="w-full h-48 object-cover object-center"
                />
                <p className="p-2 text-[11px] text-[#5A7364] bg-[#FAF8F5]">Indgangsdøren mærket Privatpsykolog</p>
              </div>
            </div>
          </div>

          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Venteværelse
            </h2>
            <p>
              Jeg har valgt ikke at have et venteværelse. <em>For at undgå, at I som klienter møder hinanden, så beder jeg om, at du ankommer og ringer på døren præcist når din tid begynder</em>.
            </p>
          </div>

          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Varighed
            </h2>
            <p>
              En enkelt session varer 45 minutter og så er der tid til booking af ny aftale, betaling og min journalskrivning derefter.
            </p>
          </div>

          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Drikkevarer og snacks
            </h2>
            <p>
              Jeg sørger for diverse varme og kolde drikkevarer og en lille snack til blodsukkeret (nogle tager den med i lommen til bilturen hjem).
            </p>
          </div>

          <div className="pt-4 space-y-2">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Betaling og kontooplysninger
            </h2>
            <p>
              Beløbet skal indbetales samme dag, som du har haft din samtale. Hvis det er en forsikringssag, afregner jeg ofte direkte med dem.
            </p>
            <ul className="space-y-1 text-xs sm:text-sm pl-4 list-disc text-[#384A3F]">
              <li><strong>Mobilepay:</strong> 400 447 (Skriv meget gerne fakturanummeret på)</li>
              <li><strong>Bankoverførsel:</strong> Nordea Erhverv Rødding: 2450-6292228846 (Skriv meget gerne fakturanummeret på)</li>
              <li><strong>Kvittering:</strong> Du kan modtage en kvittering på mobilepay/e-mail efter modtaget indbetaling.</li>
            </ul>
          </div>

          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Påmindelse om din næste tid
            </h2>
            <p>
              Hvis du ønsker det, kan jeg på sms og eller email sende en påmindelse. (Bemærk at den ikke kan besvares, da den kommer fra en computer).
            </p>
          </div>

          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Telefonnummer og afbudsregler
            </h2>
            <p>
              Telefonnummer: <strong className="whitespace-nowrap">2992 1879</strong>
            </p>
            <p className="text-[#384A3F]">
              Afbudsregler: Jeg skal modtage dit afbud på telefonnummer: 2992 1879 eller e-mail senest 24 timer før samtales opstart. Ved senere afbud eller udeblivelse opkræves det fulde beløb for den bookede behandling. Forsikringer dækker ikke udeblivelser. Så dem hæfter man personligt for.
            </p>
          </div>

          <div className="pt-4 space-y-2">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Sygeforsikringen &quot;danmark&quot;
            </h2>
            <p>
              Husk at fortælle mig, hvis du er aktivt medlem af en af deres grupper (gruppe 1, 2 eller 5). Så kan jeg sørge for automatisk indberetning, og du vil modtage en refusion på <strong>300 kr. pr. samtale</strong> direkte fra dem. Dette gælder også ved nogle forsikringssager.
            </p>
            <div className="pt-1 flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-3.5 border border-[#5f7365]">
              <ul className="space-y-1 text-xs sm:text-sm pl-4 list-disc text-[#384A3F]">
                <li><strong>Refusion:</strong> 300 kr. pr. samtale (gælder gruppe 1, 2 og 5)</li>
                <li><strong>Indberetning:</strong> Foregår automatisk og elektronisk efter hver samtale</li>
              </ul>
              <div className="shrink-0 self-start sm:self-center">
                <SygeforsikringDanmarkLogo className="w-28 sm:w-32 h-auto" />
              </div>
            </div>
          </div>

          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Tavshedspligt og journaliseringspligt
            </h2>
            <p>
              Jeg har som autoriseret psykolog både tavshedspligt og journaliseringspligt. Det betyder, at jeg ikke må fortælle, hvad du fortæller mig videre til andre, uden dit samtykke. Jeg skriver efter hver samtalesession en ordnet journal, som opbevares digitalt og krypteret i 5 år.
            </p>
          </div>

          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Samtykke
            </h2>
            <p>
              Ved oprettelse af et forløb i min klinik, vil du på e-mail modtage en elektronisk formular, hvor jeg beder om dit samtykke til følgende: At klinikken i et sikret system må indsamle og behandle dine personoplysninger. Samt at klinikken i et dobbeltkrypteret sikret system, må benytte tale-til tekst diktafon, der er AI-drevet til journaliseringen, som derved sikrer et større nærvær fra psykologen i terapisessionerne.
            </p>
          </div>

          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Løbende feedback
            </h2>
            <p>
              Jeg holder af mit arbejde og jeg gør mig umage for at forstå, støtte, give viden og hjælpe hver enkelt af mine klienter til bedring. Jeg har en lang uddannelse og mange års erfaring, men hvert forløb tilrettelægges alligevel altid individuelt efter dine personlige præferencer, problematik og ønsker. Terapi er nemlig også et menneske-møde, hvor god kemi og godt samarbejde er meget vigtige elementer, for at du kan få bedst mulig effekt af terapien. Derfor er det vigtigt for mig, at du føler, at du er vigtig og altid kan komme med din feedback, tanker, spørgsmål, ris og ros til mig undervejs i forløbet.
            </p>
          </div>

          <div className="pt-4 space-y-1">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Særligt om første session og reaktioner efter terapi
            </h2>
            <p>
              Det er helt almindeligt at være nervøs før og under første samtale. Det er jeg vant til at hjælpe med at håndtere. Efter terapien skal du være forberedt på, at kunne være meget træt og nok også ekstra følsom. Nogle klienter sørger for at holde fri efter terapi, om muligt. Andre går en tur/cykler en tur for lige at have noget alene-tid for at nå at lande tanker og følelser, før de er engageret i samtale og/eller travl hverdag igen.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
